import { render, staticRenderFns } from "./TruckFaultCodes.vue?vue&type=template&id=280c236e"
import script from "./TruckFaultCodes.vue?vue&type=script&lang=js"
export * from "./TruckFaultCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports